var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightCircleOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.643 7.183a1 1 0 0 0-1.537 1.28l1.537-1.28Zm2.546 4.617.768.64a1 1 0 0 0 0-1.28l-.768.64Zm-4.083 3.338a1 1 0 0 0 1.537 1.28l-1.537-1.28Zm.768-7.315-.768.64 3.315 3.978.768-.64.768-.64-3.314-3.978-.769.64ZM14.19 11.8l-.768-.64-3.315 3.978.768.64.769.64 3.314-3.977-.768-.64ZM12 3v1a8 8 0 0 1 8 8h2c0-5.523-4.477-10-10-10v1Zm9 9h-1a8 8 0 0 1-8 8v2c5.523 0 10-4.477 10-10h-1Zm-9 9v-1a8 8 0 0 1-8-8H2c0 5.523 4.477 10 10 10v-1Zm-9-9h1a8 8 0 0 1 8-8V2C6.477 2 2 6.477 2 12h1Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircleOutlineIcon);
export default __webpack_public_path__ + "static/media/arrow-right-circle-outline-icon.3909c9dff129d113c03ac0b45f2225eb.svg";
export { ForwardRef as ReactComponent };